module.exports = __webpack_public_path__ + "img/f5c86aa.jpg";